import { api } from 'new/api/axios';
import { createEndpoint } from 'new/api/utils';
import {
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  LogoutResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from './types';

export const loginEndpoint = createEndpoint<LoginResponse, LoginRequest>({
  url: '/accounts/login',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const forgotPasswordEndpoint = createEndpoint<
  undefined,
  ForgotPasswordRequest
>({
  url: '/accounts/forgot-password',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const resetPasswordEndpoint = createEndpoint<
  ResetPasswordResponse,
  ResetPasswordRequest
>({
  url: '/accounts/reset-password',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const logoutEndpoint = createEndpoint<LogoutResponse, LogoutRequest>({
  url: '/accounts/set-logout',
  endpoint: ({ url, params }) => api.post(url, params),
});
